/* import __COLOCATED_TEMPLATE__ from './warm-transfer-team-waiting.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { registerDestructor } from '@ember/destroyable';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface Signature {
  Args: {
    teamName?: string;
  };
  Element: HTMLDivElement;
}

const MESSAGE_ROTATION_INTERVAL = 3000;

export default class WarmTransferTeamWaiting extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked messageIndex = 0;

  private messages = [
    'calling.modal.warm-transfer-team.waiting-messages.waiting',
    'calling.modal.warm-transfer-team.waiting-messages.hold-on',
    'calling.modal.warm-transfer-team.waiting-messages.one-moment',
    'calling.modal.warm-transfer-team.waiting-messages.please-wait',
    'calling.modal.warm-transfer-team.waiting-messages.hang-tight',
  ];

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);

    let timer = setInterval(() => {
      this.messageIndex = (this.messageIndex + 1) % this.messages.length;
    }, MESSAGE_ROTATION_INTERVAL);

    registerDestructor(this, () => {
      clearInterval(timer);
    });
  }

  get currentMessage(): string {
    return this.intl.t(this.messages[this.messageIndex]);
  }

  get teamInitial(): string {
    return this.args.teamName?.charAt(0).toUpperCase() ?? '?';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::WarmTransferTeamWaiting': typeof WarmTransferTeamWaiting;
    'inbox2/calling/warm-transfer-team-waiting': typeof WarmTransferTeamWaiting;
  }
}
